import { ModalProps } from "antd";
import { useEffect, useRef, useState } from "react";
import {
  EXCEL_EXTENSIONS,
  IMAGE_FILE_EXTENSIONS,
  PDF_EXTENSION,
  TXT_EXTENSION,
  VIDEO_FILE_EXTENSIONS,
  WORD_EXTENSIONS,
  AUDIO_EXTENSIONS,
} from "@lhd/constants";
import Excel from "./Excell";
import PDF from "./PDF";
import Word from "./Word";
import Text from "./Text";
import Video from "./Video";
import Img from "./Img";
import Audio from "./Audio";

export interface IProps {
  modalProps: ModalProps;
  uri?: string;
}
const useModalPreviewOffice = (props: IProps) => {
  const { uri } = props;
  const [isResizing, setIsResizing] = useState(false);
  const [loading, setLoading] = useState(true);

  const refContainer = useRef<HTMLDivElement>(null);
  const nameArray = decodeURI(uri || "").split("/");
  const nameFile = nameArray[nameArray.length - 1] || "";
  const extension = nameFile.split(".").pop();
  const renderPreview = () => {
    if (!extension) return <div></div>;
    const extensionLowerCase = extension.toLowerCase();
    if (EXCEL_EXTENSIONS.includes(extensionLowerCase)) {
      return <Excel uri={uri} setLoading={setLoading} />;
    } else if (WORD_EXTENSIONS.includes(extensionLowerCase)) {
      return <Word uri={uri} setLoading={setLoading} />;
    } else if (extensionLowerCase === PDF_EXTENSION) {
      return <PDF uri={uri} setLoading={setLoading} />;
    } else if (extensionLowerCase === TXT_EXTENSION) {
      return <Text uri={uri} setLoading={setLoading} />;
    } else if (VIDEO_FILE_EXTENSIONS.includes(extensionLowerCase)) {
      return <Video uri={uri} setLoading={setLoading} />;
    } else if (IMAGE_FILE_EXTENSIONS.includes(extensionLowerCase)) {
      return <Img uri={uri} setLoading={setLoading} />;
    } else if (AUDIO_EXTENSIONS.includes(extensionLowerCase)) {
      return <Audio uri={uri} setLoading={setLoading} />;
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    let xStart: any = null;
    let currentMaxWidth: any;

    if (isResizing) {
      window.addEventListener(
        "mouseup",
        () => {
          setIsResizing(false);
        },
        { signal: controller.signal },
      );

      window.addEventListener(
        "mousemove",
        (e) => {
          if (!xStart) {
            xStart = e.x;
          }
          if (!currentMaxWidth) {
            currentMaxWidth = refContainer.current?.clientWidth || 0;
          }
          const widthResize = (xStart - e.x) * 2;
          if (refContainer.current) {
            refContainer.current.style.maxWidth =
              currentMaxWidth + widthResize + "px";
          }
        },
        { signal: controller.signal },
      );
    }

    return () => {
      controller.abort();
    };
  }, [refContainer.current, isResizing]);

  useEffect(() => {
    // prevent right click
    const controller = new AbortController();
    document.addEventListener(
      "contextmenu",
      (event) => event.preventDefault(),
      {
        signal: controller.signal,
      },
    );
    return () => {
      controller.abort();
    };
  }, []);

  return {
    ...props,
    refContainer,
    isResizing,
    setIsResizing,
    setLoading,
    loading,
    nameFile,
    renderPreview,
  };
};

export type Props = ReturnType<typeof useModalPreviewOffice>;

export default useModalPreviewOffice;
